<template>
  <div class="appeal-list-container">
    <area-appeal-list-panel />
  </div>
</template>

<script>
import AreaAppealListPanel from './AreaAppealListPanel.vue'

export default {
  name: 'AreaAppealList',
  components: {
    AreaAppealListPanel
  }
}
</script>

<style lang="scss" scoped>
.appeal-list-container {
  padding: 20px;
}
</style>
